var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageWrapper"},[_c('div',{staticClass:"topbar"},[_c('div',{staticStyle:{"display":"flex"}},[_c('H2',[_vm._v("Customer Settings")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }